import React from "react";

const TableSeparator = () => {
    return (
        <li className="btn-toolbar-sep"></li>
    )
}

export default TableSeparator;